
<div class="modal-body-detail-row">
    <a :href="link" class="d-flex align-items-center">{{ title }}</a>
</div>
